import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, { stadiumId: number; query: string }>({
    query: (body) => ({
      url: `v5/pitch-owner/players/search?stadium_id=${body.stadiumId}&query=${body.query}`,
      method: 'GET',
    }),
  });

export interface SearchedUser {
  id: number;
  name: string;
  phone_number: string;
}
